// Local-only UI strings the API doesn't ship (mode toggle labels, scroll cue, etc.).
// Catalogs ship as JSON for V1.1 i18n integration; this minimal map keeps V1 lean.

type StringMap = Record<string, Record<string, string>>;

export const LOCAL_UI: StringMap = {
  de: {
    mode_letter: "Brief",
    mode_chat: "Gespräch",
    continue: "WEITER",
    chat_listening: "Ich höre zu.",
    chat_what: "Was willst du?",
    chat_go_on: "Weiter.",
    chat_proof: "Beweis?",
    chat_think: "Ich denk darüber nach.",
    chat_try: "Ich versuch's.",
    chat_switch: "Andere Zielgruppe",
    chat_typing: "tippt … (klick zum Überspringen)",
    decisions_today: "Entscheidungen heute",
    future: "Zukunft",
    fallback_hint: "Übersetzung folgt",
  },
  en: {
    mode_letter: "Letter",
    mode_chat: "Chat",
    continue: "CONTINUE",
    chat_listening: "I'm listening.",
    chat_what: "What do you want?",
    chat_go_on: "Go on.",
    chat_proof: "Proof?",
    chat_think: "I'll think about it.",
    chat_try: "I'll try.",
    chat_switch: "Switch audience",
    chat_typing: "typing … (click to skip)",
    decisions_today: "decisions today",
    future: "Future",
    fallback_hint: "Translation pending",
  },
};

export function localUi(locale: string, key: string): string {
  return LOCAL_UI[locale]?.[key] ?? LOCAL_UI.en[key] ?? key;
}
